module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_1_1@2x.a81f15c5.png";